<script setup>
</script>

<template>
    <div class="d-flex mt-2 justify-space-around">
        <v-btn variant="outlined" size="small">SLIP</v-btn>
        <v-btn variant="outlined" size="small">PLCB</v-btn>
    </div>
</template>
